// extracted by mini-css-extract-plugin
export default {"task_name":"CreateTask_task_name__YSIzX"};